// 统计维度下拉项
export const statisDimension = {
	meterRate: [{ value: 'device_type_id', label: '设备类型', columnKey: 'deviceTypeName' }],

	useWaterRecord: [
		{ value: 0, label: '档案' },
		{ value: 1, label: '设备类型' },
		{ value: 2, label: '客户类型' },
		{ value: 3, label: '区域' },
	],

	alarmDeal: [
		{ value: 0, label: '设备类型+告警类型' },
		{ value: 1, label: '设备类型' },
	],
}
